<template>
  <div :key="'webboard-thread-list'">
    <li v-for="(message, index) in messages" :key="String(message.id)">
      {{ index }} {{ message }}
    </li>
    <!-- <li class="cursor-pointer email__mail-item" v-for="(message, index) in messages"
      :key="String(message.id)" :style="{transitionDelay: (index * 0.1) + 's'}">
      <MessageListItem :index="index" :message="message" :isSelected="false">
        <MessageHeader :message="message" />
      </MessageListItem>
    </li> -->
  </div>
</template>

<script>
import { state } from "../../data";
// import MessageListItem from "../MessageListItem";
import { constructMessagesFromList } from "../../data";

export default {
  components: {
    // MessageListItem,
    // MessageHeader: () => import("./MessageHeader.vue")
  },
  data() {
    return {
      localData: state.local,
      topics: []
    }
  },
  watch: {
    'localData.activeListType'(type) {
      alert(type);
    }
  },
  computed: {
    messages() {
      return this.localData.messagePool["webboard"]
    }
  },
  mounted() {
    const { topics } = constructMessagesFromList("webboard", "all");
    this.topics = topics;
    // this.localData.messagePool["webboard"] = Object.assign(this.localData.messagePool["webboard"], topics);
  }
}
</script>
